import { Component, OnInit, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Output() menu = new EventEmitter<boolean>();

  isActive = false;
  hMenu = 0;
  newHMenu = 0;
  arrayMenu = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private translate: TranslateService
  ) { }

  ngOnInit() {
  }

  resetView() {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('view-page', 'map-view');
      sessionStorage.removeItem('current');
      sessionStorage.removeItem('survey');
      sessionStorage.removeItem('survey-list');
    }
  }

  toggleMenu() {
    this.isActive = !this.isActive;
    this.menu.emit(this.isActive);
  }

  toggleSubMenu(event) {
    event.target.nextElementSibling.classList.toggle('sub');
  }

}
